module.exports = __webpack_public_path__ + "static/media/nvidia_logo.74c6f894.png";